import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';

// import { useAuth } from 'Context/auth';
import { useUserStore } from 'Store/userStore';
import NotificationService from 'Services/NotificationService';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faHome, faSitemap, faUserCircle } from '@fortawesome/free-solid-svg-icons';
import { Navbar, Nav, NavDropdown, Container, Badge } from 'react-bootstrap';

const Header = ({ logOut }) => {
    const user = useUserStore((state) => state.user);
    const [countNotification, setCountNotification] = useState(0);
    const history = useHistory();

    useEffect(() => {
        if (user) loadCountNotifications();
    }, [user]);

    useEffect(() => {
        return history.listen(() => {
            if (user) loadCountNotifications();
        });
    }, [user, history]);

    const loadCountNotifications = () => {
        NotificationService.countFreshNotifications()
            .then((result) => {
                if (result.status === 200) {
                    setCountNotification(result.data);
                }
            })
            .catch(() => {
                setCountNotification(0);
            });
    };

    return (
        <Navbar bg="light" expand="lg">
            <Container fluid>
                <Navbar.Brand as={Link} to="/" className="guide_navbar-logo">
                    <span className="header_cli-logo-text">CLI</span>
                    <span className="header_cli_am-logo-text">AM</span>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ml-auto pr-5">
                        {user && (
                            <>
                                <Nav.Link as={Link} to="/" className="guide_navbar-home-item">
                                    | &nbsp;
                                    <FontAwesomeIcon icon={faHome} />
                                    &nbsp; Accueil &nbsp;
                                    <div className="headerNavNotification">
                                        <FontAwesomeIcon icon={faBell} color={'#1f70b8'} size="sm" />
                                        <Badge
                                            pill
                                            variant="success"
                                            style={{ backgroundColor: '#69be56', fontSize: '0.6rem' }}
                                        >
                                            {countNotification}
                                        </Badge>
                                    </div>
                                </Nav.Link>
                                <Nav.Link as={Link} to="/apps" className="guide_navbar-apps-item">
                                    | &nbsp;
                                    <FontAwesomeIcon icon={faSitemap} /> &nbsp;Mes Applications
                                </Nav.Link>
                            </>
                        )}
                        <NavDropdown
                            className="guide_account-section"
                            title={
                                <>
                                    <FontAwesomeIcon icon={faUserCircle} /> &nbsp;
                                    {user ? `${user.FirstName} ${user.LastName}` : 'Mon compte'}
                                </>
                            }
                            id="basic-nav-dropdown"
                        >
                            {!user ? (
                                <NavDropdown.Item as={Link} to="/login">
                                    Se connecter
                                </NavDropdown.Item>
                            ) : (
                                ''
                            )}
                            {user ? (
                                <>
                                    <NavDropdown.Item as={Link} to="/profile/password">
                                        Profile
                                    </NavDropdown.Item>
                                    <NavDropdown.Item as={Link} to="/my-terms-history">
                                        T/C Historique
                                    </NavDropdown.Item>
                                    <NavDropdown.Item onClick={() => logOut(true)}>
                                        <span style={{ color: 'red' }}>Logout</span>
                                    </NavDropdown.Item>
                                </>
                            ) : (
                                ''
                            )}
                        </NavDropdown>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default Header;
